import type { LucideIcon } from 'lucide-react'
import {
  FileText,
  Users,
  Calculator,
  Wrench,
  FileSignature,
  AlertTriangle,
  Settings,
  Scale,
  Mail,
  Building2,
} from 'lucide-react'

/**
 * Map des icônes pour chaque dossier système
 * Correspond aux slugs REELS en base de données
 *
 * Les 10 dossiers système :
 * 1. Documents constitutifs (documents-constitutifs)
 * 2. Assemblées générales (assemblees-generales)
 * 3. Comptabilité (comptabilite)
 * 4. Travaux (travaux)
 * 5. Diagnostics technique (diagnostics-technique)
 * 6. Contrats prestataires (contrats-prestataires)
 * 7. Sinistres assurances (sinistres-assurances)
 * 8. Juridique (juridique)
 * 9. Correspondance (correspondance)
 * 10. Copropriétaires (coproprietaires)
 */
export const SYSTEM_FOLDER_ICONS: Record<string, LucideIcon> = {
  'documents-constitutifs': FileText, // Documents constitutifs
  'assemblees-generales': Users, // Assemblées générales
  comptabilite: Calculator, // Comptabilité
  travaux: Wrench, // Travaux
  'diagnostics-technique': Settings, // Diagnostics technique
  'contrats-prestataires': FileSignature, // Contrats prestataires
  'sinistres-assurances': AlertTriangle, // Sinistres assurances
  juridique: Scale, // Juridique
  correspondance: Mail, // Correspondance
  coproprietaires: Building2, // Copropriétaires
}

/**
 * Map des couleurs pour chaque dossier système (Chakra UI colors)
 */
export const SYSTEM_FOLDER_COLORS: Record<string, string> = {
  'documents-constitutifs': '#3182CE', // blue
  'assemblees-generales': '#805AD5', // purple
  comptabilite: '#38A169', // green
  travaux: '#DD6B20', // orange
  'contrats-prestataires': '#D69E2E', // yellow
  'sinistres-assurances': '#E53E3E', // red
  'diagnostics-technique': '#319795', // teal
  juridique: '#D53F8C', // pink
  correspondance: '#4299E1', // blue (lighter)
  coproprietaires: '#2C5282', // blue (darker)
}

/**
 * Slugs des dossiers système dans l'ordre d'affichage
 */
export const SYSTEM_FOLDER_SLUGS = [
  'documents-constitutifs',
  'assemblees-generales',
  'comptabilite',
  'travaux',
  'diagnostics-technique',
  'contrats-prestataires',
  'sinistres-assurances',
  'juridique',
  'correspondance',
  'coproprietaires',
] as const

export type SystemFolderSlug = (typeof SYSTEM_FOLDER_SLUGS)[number]
